// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Support-pageTitle-vg37E {
    font-size: 22px;
    font-weight: 700;
    color: #1F2733;
    margin: 0 0 8px;
    font-family: 'Poppins', sans-serif;
}

.Support-subText-V8OdS {
    font-size: 15px;
    color: #555;
    margin: 0 0 22px;
}

.Support-channelList-MwxGx {
    list-style: none;
    padding: 0;
    margin: 0 0 28px;
}

.Support-channelItem-UBTiV {
    margin-bottom: 14px;
}

.Support-channelLink-oPP2d {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    background: #fff;
    text-decoration: none;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
}

.Support-channelLink-oPP2d:hover {
    border-color: #D32F2F;
    background: #FFF6F4;
    text-decoration: none;
}

.Support-channelInfo-VSeE5 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 4px;
}

.Support-channelLabel-d8yye {
    font-size: 15px;
    font-weight: 600;
    color: #1F2733;
}

.Support-channelValue-MhASH {
    font-size: 14px;
    color: #555;
}

.Support-channelArrow-sw1pS {
    font-size: 26px;
    line-height: 1;
    color: #D32F2F;
}

.Support-faqCard-uELo8 {
    background: #fff;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    padding: 24px;
    max-width: 640px;
}

.Support-faqTitle-etgFS {
    font-size: 18px;
    font-weight: 700;
    color: #1F2733;
    margin: 0 0 8px;
}

.Support-faqText-t_v3U {
    font-size: 15px;
    line-height: 1.6;
    color: #555;
    margin: 0 0 20px;
}

.Support-faqBtn-sUdoL {
    width: auto;
    min-width: 180px;
    text-decoration: none;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.Support-faqBtn-sUdoL:hover {
    text-decoration: none;
}

.Support-emptyText-YIBxp {
    color: #777;
    font-size: 15px;
    padding: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/routes/support/Support.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,iCAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB","sourcesContent":[".pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0 0 8px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.subText {\n    font-size: 15px;\n    color: #555;\n    margin: 0 0 22px;\n}\n\n.channelList {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 28px;\n}\n\n.channelItem {\n    margin-bottom: 14px;\n}\n\n.channelLink {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 18px 20px;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    background: #fff;\n    text-decoration: none;\n    transition: all .15s ease;\n}\n\n.channelLink:hover {\n    border-color: #D32F2F;\n    background: #FFF6F4;\n    text-decoration: none;\n}\n\n.channelInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.channelLabel {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1F2733;\n}\n\n.channelValue {\n    font-size: 14px;\n    color: #555;\n}\n\n.channelArrow {\n    font-size: 26px;\n    line-height: 1;\n    color: #D32F2F;\n}\n\n.faqCard {\n    background: #fff;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    padding: 24px;\n    max-width: 640px;\n}\n\n.faqTitle {\n    font-size: 18px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0 0 8px;\n}\n\n.faqText {\n    font-size: 15px;\n    line-height: 1.6;\n    color: #555;\n    margin: 0 0 20px;\n}\n\n.faqBtn {\n    width: auto;\n    min-width: 180px;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.faqBtn:hover {\n    text-decoration: none;\n}\n\n.emptyText {\n    color: #777;\n    font-size: 15px;\n    padding: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitle": `Support-pageTitle-vg37E`,
	"subText": `Support-subText-V8OdS`,
	"channelList": `Support-channelList-MwxGx`,
	"channelItem": `Support-channelItem-UBTiV`,
	"channelLink": `Support-channelLink-oPP2d`,
	"channelInfo": `Support-channelInfo-VSeE5`,
	"channelLabel": `Support-channelLabel-d8yye`,
	"channelValue": `Support-channelValue-MhASH`,
	"channelArrow": `Support-channelArrow-sw1pS`,
	"faqCard": `Support-faqCard-uELo8`,
	"faqTitle": `Support-faqTitle-etgFS`,
	"faqText": `Support-faqText-t_v3U`,
	"faqBtn": `Support-faqBtn-sUdoL`,
	"emptyText": `Support-emptyText-YIBxp`
};
module.exports = ___CSS_LOADER_EXPORT___;
